import { Button } from '@skin-seoul/design-system';
import type { ComponentProps } from 'react';

type ViewAllButtonProps = ComponentProps<typeof Button> & {
  theme?: 'light' | 'dark';
};

const ViewAllButton = ({ theme = 'light', ...rest }: ViewAllButtonProps) => {
  return (
    <Button
      variant="outline"
      className={`h-[48px] bg-transparent rounded-[8px] border font-regular text-paragraph-small p-4 w-full tablet:w-[332px] ${
        theme === 'light'
          ? 'active:bg-primary-500 active:text-generic-0'
          : 'active:bg-generic-0 active:text-generic-100 active:border-generic-0'
      }`}
      {...rest}
    >
      View all
    </Button>
  );
};

export default ViewAllButton;
